// extracted by mini-css-extract-plugin
module.exports = {"title":"Moved_title__HXiSY","body":"Moved_body__89B5N","site":"Moved_site__EF_Cs"};